module.exports = __webpack_public_path__ + "img/26.965dbc98.jpg";